import React from 'react';
import { createRoot } from 'react-dom/client';
import ReportDoc from '../components/Common/ReportDoc';
import { exportPagesToPdf } from './domToPdf';

/* Скачать итоги недели одним кликом из колокольчика: собираем листы в невидимом
   контейнере, снимаем с них PDF и убираем за собой. Цифры берём из самого
   уведомления — они зафиксированы в момент отправки. */
export async function downloadReportPdf(notification) {
  const report = notification?.data;
  if (!report?.kind) throw new Error('в уведомлении нет данных отчёта');

  const host = document.createElement('div');
  host.style.cssText = 'position:fixed;left:-10000px;top:0;width:794px;';
  document.body.appendChild(host);
  const root = createRoot(host);
  try {
    const pages = await new Promise((resolve, reject) => {
      const timer = setTimeout(() => reject(new Error('отчёт не собрался')), 20000);
      root.render(<ReportDoc report={report} onReady={(els) => { clearTimeout(timer); resolve(els); }} />);
    });
    if (!pages.length) throw new Error('пустой отчёт');
    const name = `${report.kind === 'digest' ? 'Итоги недели' : 'Сводка за неделю'} · ${report.week?.label || ''}`.trim();
    await exportPagesToPdf(pages, `${name.replace(/[\\/:*?"<>|]/g, ' ')}.pdf`);
  } finally {
    setTimeout(() => root.unmount(), 0);
    setTimeout(() => host.remove(), 200);
  }
}
